export default function(config: any) {
	config.baseURL = process.env.VUE_APP_API_ROOT || 'https://api.mygosystems.com/v1/'

	// config.auth = {
	// 	username: 'ss',
	// 	password: 'bcspca',
	// }

	config.headers = {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
		'x-client': localStorage.client || null,
		'Authorization': localStorage.authKey || null,
	}
}
